// Mantis typography configuration - Thai Sarabun font
export default function Typography() {
  return {
    fontFamily: `'Sarabun', 'Inter', 'Public Sans', sans-serif`,
    fontSize: 16,
    htmlFontSize: 16,
    h1: {
      fontFamily: `'Sarabun', sans-serif`,
      fontWeight: 700,
      fontSize: '2.375rem',
      lineHeight: 1.21
    },
    h2: {
      fontFamily: `'Sarabun', sans-serif`,
      fontWeight: 700,
      fontSize: '1.875rem',
      lineHeight: 1.27
    },
    h3: {
      fontFamily: `'Sarabun', sans-serif`,
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.33
    },
    h4: {
      fontFamily: `'Sarabun', sans-serif`,
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.4
    },
    h5: {
      fontFamily: `'Sarabun', sans-serif`,
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.5
    },
    h6: {
      fontFamily: `'Sarabun', sans-serif`,
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: 1.57
    },
    caption: {
      fontFamily: `'Sarabun', sans-serif`,
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: 1.66
    },
    body1: {
      fontFamily: `'Sarabun', sans-serif`,
      fontSize: '1rem',
      lineHeight: 1.57
    },
    body2: {
      fontFamily: `'Sarabun', sans-serif`,
      fontSize: '0.875rem',
      lineHeight: 1.66
    },
    subtitle1: {
      fontFamily: `'Sarabun', sans-serif`,
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.57
    },
    subtitle2: {
      fontFamily: `'Sarabun', sans-serif`,
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.66
    },
    overline: {
      fontFamily: `'Sarabun', sans-serif`,
      lineHeight: 1.66
    },
    button: {
      fontFamily: `'Sarabun', sans-serif`,
      textTransform: 'capitalize' as const,
      fontWeight: 600
    }
  };
}
